/**
 * Label, hint and error around a form control. The control itself receives `id`,
 * `aria-describedby` and `aria-invalid` from its owner so screen readers read the hint and error.
 */
const FieldFrame = ({ id, label, hint, error, children }) => {
  return (
    <div className="comp-field" data-invalid={error ? 'true' : undefined}>
      {label && (
        <label className="comp-field__label" htmlFor={id}>
          {label}
        </label>
      )}
      {children}
      {hint && !error && (
        <p className="comp-field__hint" id={`${id}-hint`}>
          {hint}
        </p>
      )}
      {error && (
        <p className="comp-field__error" id={`${id}-error`}>
          {error}
        </p>
      )}
    </div>
  );
};

export default FieldFrame;
